export default "__VITE_ASSET__DsvafhRR__"